import React from "react";

const GREEN = "#2E8056";

export function InvoiceEditIcon({ color = GREEN }) {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14.5337 8.4V7.55C14.5337 4.34445 14.5337 2.74168 13.5838 1.74583C12.6338 0.75 11.105 0.75 8.04725 0.75H7.23652C4.17878 0.75 2.64991 0.75 1.69999 1.74583C0.750066 2.74165 0.750049 4.34441 0.750025 7.54994L0.75 10.95C0.749968 14.1555 0.74996 15.7583 1.69985 16.7541C2.64977 17.7499 4.17869 17.75 7.23644 17.75M4.39864 5H10.8851M4.39864 9.25H10.8851M9.26347 16.7528V17.75H10.2149C10.5468 17.75 10.7128 17.75 10.862 17.6852C11.0112 17.6204 11.1286 17.4974 11.3633 17.2514L15.2743 13.151C15.4957 12.9189 15.6063 12.8029 15.6655 12.6778C15.7782 12.4396 15.7782 12.1601 15.6655 11.9219C15.6063 11.7967 15.4957 11.6807 15.2743 11.4486C15.0529 11.2166 14.9422 11.1005 14.8228 11.0385C14.5956 10.9205 14.3288 10.9205 14.1016 11.0385C13.9823 11.1005 13.8715 11.2166 13.6502 11.4486L9.73917 15.549C9.50444 15.795 9.38711 15.918 9.32533 16.0744C9.26347 16.2309 9.26347 16.4048 9.26347 16.7528Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DollarHandIcon({ color = GREEN }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M13.3086 0C13.7228 0 14.0586 0.33579 14.0586 0.75V0.91898C14.807 1.10815 15.3609 1.78601 15.3609 2.59323C15.3609 3.00744 15.0251 3.34323 14.6109 3.34323C14.1967 3.34323 13.8609 3.00744 13.8609 2.59323C13.8609 2.46796 13.7594 2.36641 13.6341 2.36641H13.2391C12.9724 2.36641 12.7563 2.58257 12.7563 2.84921C12.7563 3.05046 12.8811 3.2306 13.0695 3.30127L14.0744 3.67811C14.8482 3.96833 15.3609 4.70814 15.3609 5.53464C15.3609 6.39065 14.8185 7.11996 14.0586 7.39759V7.63372C14.0586 8.0479 13.7228 8.3837 13.3086 8.3837C12.8944 8.3837 12.5586 8.0479 12.5586 7.63372V7.46488C11.8101 7.2757 11.2563 6.59785 11.2563 5.79062C11.2563 5.37641 11.5921 5.04062 12.0063 5.04062C12.4205 5.04062 12.7563 5.37641 12.7563 5.79062C12.7563 5.91589 12.8578 6.01744 12.9831 6.01744H13.3781C13.6448 6.01744 13.8609 5.80129 13.8609 5.53464C13.8609 5.3334 13.7361 5.15326 13.5477 5.08259L12.5428 4.70575C11.7689 4.41552 11.2563 3.67571 11.2563 2.84921C11.2563 1.99321 11.7987 1.2639 12.5586 0.98626V0.75C12.5586 0.33579 12.8944 0 13.3086 0Z"
        fill={color}
      />
      <path
        d="M17.4266 9.0844C18.0839 8.5513 19.0447 8.6316 19.6044 9.2664C20.1114 9.8415 20.1317 10.6979 19.6525 11.2964L15.7859 16.125C15.4104 16.5938 14.8423 16.8667 14.2417 16.8667H8.0685C7.8825 16.8667 7.70317 16.9358 7.56527 17.0606L7.04042 17.5355C7.14503 17.864 7.01125 18.2324 6.7004 18.4119L4.1238 19.8995C3.76508 20.1066 3.30638 19.9837 3.09928 19.625L0.100608 14.4311C-0.106502 14.0724 0.0164074 13.6137 0.375127 13.4066L2.95173 11.919C3.18986 11.7815 3.47206 11.7895 3.69546 11.9153L5.38764 10.5626C5.94114 10.1201 6.64057 9.8151 7.41278 9.8116C8.2262 9.8079 9.5119 9.8799 10.6754 10.3045H13.2732C13.9345 10.3045 14.512 10.6637 14.8212 11.1975L17.4266 9.0844ZM6.55886 15.9483C6.97255 15.574 7.51056 15.3667 8.0685 15.3667H14.2417C14.3869 15.3667 14.5242 15.3007 14.615 15.1874L18.4816 10.3588C18.5053 10.3292 18.5043 10.2868 18.4792 10.2584C18.4515 10.227 18.404 10.223 18.3715 10.2494L14.5205 13.3728C14.1984 13.6865 13.7583 13.8798 13.2732 13.8798H10.5383C10.1241 13.8798 9.7883 13.544 9.7883 13.1298C9.7883 12.7156 10.1241 12.3798 10.5383 12.3798H13.2732C13.3195 12.3798 13.3633 12.3688 13.4021 12.3494C13.4102 12.3422 13.4184 12.3352 13.4269 12.3284L13.5 12.2691C13.5381 12.2203 13.5608 12.1589 13.5608 12.0922C13.5608 11.9333 13.432 11.8045 13.2732 11.8045H10.5912C10.4613 11.8045 10.3365 11.7799 10.222 11.7363C9.296 11.3834 8.1887 11.3081 7.41955 11.3116C7.04628 11.3133 6.66549 11.4614 6.32425 11.7342L4.53627 13.1635L6.2864 16.1948L6.55886 15.9483ZM1.77464 14.3307L4.02332 18.2255L5.30088 17.4879L3.05221 13.5931L1.77464 14.3307Z"
        fill={color}
      />
    </svg>
  );
}

export function InvoiceDocIcon({ color = GREEN }) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3.33333 13.3333H10V11.6667H3.33333V13.3333ZM3.33333 10H10V8.33333H3.33333V10ZM1.66667 16.6667C1.20833 16.6667 0.815972 16.5035 0.489583 16.1771C0.163194 15.8507 0 15.4583 0 15V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H8.33333L13.3333 5V15C13.3333 15.4583 13.1701 15.8507 12.8438 16.1771C12.5174 16.5035 12.125 16.6667 11.6667 16.6667H1.66667ZM7.5 5.83333V1.66667H1.66667V15H11.6667V5.83333H7.5ZM1.66667 1.66667V5.83333V15V1.66667Z"
        fill={color}
      />
    </svg>
  );
}

export function DollarSignIcon({ color = GREEN }) {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10.7 6C10.501 5.43524 10.1374 4.94297 9.65627 4.58654C9.17509 4.23011 8.59825 4.02583 8 4H4C3.20435 4 2.44129 4.31607 1.87868 4.87868C1.31607 5.44129 1 6.20435 1 7C1 7.79565 1.31607 8.55871 1.87868 9.12132C2.44129 9.68393 3.20435 10 4 10H8C8.79565 10 9.55871 10.3161 10.1213 10.8787C10.6839 11.4413 11 12.2044 11 13C11 13.7956 10.6839 14.5587 10.1213 15.1213C9.55871 15.6839 8.79565 16 8 16H4C3.40175 15.9742 2.82491 15.7699 2.34373 15.4135C1.86255 15.057 1.49905 14.5648 1.3 14M6 1V4M6 16V19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ReceiptIcon({ color = GREEN }) {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M2.5 16.6667C1.80556 16.6667 1.21528 16.4236 0.729167 15.9375C0.243056 15.4514 0 14.8611 0 14.1667V11.6667H2.5V0L3.75 1.25L5 0L6.25 1.25L7.5 0L8.75 1.25L10 0L11.25 1.25L12.5 0L13.75 1.25L15 0V14.1667C15 14.8611 14.7569 15.4514 14.2708 15.9375C13.7847 16.4236 13.1944 16.6667 12.5 16.6667H2.5ZM12.5 15C12.7361 15 12.934 14.9201 13.0938 14.7604C13.2535 14.6007 13.3333 14.4028 13.3333 14.1667V2.5H4.16667V11.6667H11.6667V14.1667C11.6667 14.4028 11.7465 14.6007 11.9062 14.7604C12.066 14.9201 12.2639 15 12.5 15ZM5 5.83333V4.16667H10V5.83333H5ZM5 8.33333V6.66667H10V8.33333H5ZM11.6667 5.83333C11.4306 5.83333 11.2326 5.75347 11.0729 5.59375C10.9132 5.43403 10.8333 5.23611 10.8333 5C10.8333 4.76389 10.9132 4.56597 11.0729 4.40625C11.2326 4.24653 11.4306 4.16667 11.6667 4.16667C11.9028 4.16667 12.1007 4.24653 12.2604 4.40625C12.4201 4.56597 12.5 4.76389 12.5 5C12.5 5.23611 12.4201 4.56597 12.2604 5.59375C12.1007 5.75347 11.9028 5.83333 11.6667 5.83333ZM11.6667 8.33333C11.4306 8.33333 11.2326 8.25347 11.0729 8.09375C10.9132 7.93403 10.8333 7.73611 10.8333 7.5C10.8333 7.26389 10.9132 7.06597 11.0729 6.90625C11.2326 6.74653 11.4306 6.66667 11.6667 6.66667C11.9028 6.66667 12.1007 6.74653 12.2604 6.90625C12.4201 7.06597 12.5 7.26389 12.5 7.5C12.5 7.73611 12.4201 7.93403 12.2604 8.09375C12.1007 8.25347 11.9028 8.33333 11.6667 8.33333ZM2.5 15H10V13.3333H1.66667V14.1667C1.66667 14.4028 1.74653 14.6007 1.90625 14.7604C2.06597 14.9201 2.26389 15 2.5 15ZM1.66667 15C1.66667 15 1.66667 14.9201 1.66667 14.7604C1.66667 14.6007 1.66667 14.4028 1.66667 14.1667V13.3333V15Z"
        fill={color}
      />
    </svg>
  );
}

export function PeopleIcon({ color = GREEN }) {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0 13.3333V11C0 10.5278 0.121528 10.0938 0.364583 9.69792C0.607639 9.30208 0.930556 9 1.33333 8.79167C2.19444 8.36111 3.06944 8.03819 3.95833 7.82292C4.84722 7.60764 5.75 7.5 6.66667 7.5C7.58333 7.5 8.48611 7.60764 9.375 7.82292C10.2639 8.03819 11.1389 8.36111 12 8.79167C12.4028 9 12.7257 9.30208 12.9688 9.69792C13.2118 10.0938 13.3333 10.5278 13.3333 11V13.3333H0ZM15 13.3333V10.8333C15 10.2222 14.8299 9.63542 14.4896 9.07292C14.1493 8.51042 13.6667 8.02778 13.0417 7.625C13.75 7.70833 14.4167 7.85069 15.0417 8.05208C15.6667 8.25347 16.25 8.5 16.7917 8.79167C17.2917 9.06944 17.6736 9.37847 17.9375 9.71875C18.2014 10.059 18.3333 10.4306 18.3333 10.8333V13.3333H15ZM6.66667 6.66667C5.75 6.66667 4.96528 6.34028 4.3125 5.6875C3.65972 5.03472 3.33333 4.25 3.33333 3.33333C3.33333 2.41667 3.65972 1.63194 4.3125 0.979167C4.96528 0.326389 5.75 0 6.66667 0C7.58333 0 8.36806 0.326389 9.02083 0.979167C9.67361 1.63194 10 2.41667 10 3.33333C10 4.25 9.67361 5.03472 9.02083 5.6875C8.36806 6.34028 7.58333 6.66667 6.66667 6.66667ZM15 3.33333C15 4.25 14.6736 5.03472 14.0208 5.6875C13.3681 6.34028 12.5833 6.66667 11.6667 6.66667C11.5139 6.66667 11.3194 6.64931 11.0833 6.61458C10.8472 6.57986 10.6528 6.54167 10.5 6.5C10.875 6.05556 11.1632 5.5625 11.3646 5.02083C11.566 4.47917 11.6667 3.91667 11.6667 3.33333C11.6667 2.75 11.566 2.1875 11.3646 1.64583C11.1632 1.10417 10.875 0.611111 10.5 0.166667C10.6944 0.0972222 10.8889 0.0520833 11.0833 0.03125C11.2778 0.0104167 11.4722 0 11.6667 0C12.5833 0 13.3681 0.326389 14.0208 0.979167C14.6736 1.63194 15 2.41667 15 3.33333ZM1.66667 11.6667H11.6667V11C11.6667 10.8472 11.6285 10.7083 11.5521 10.5833C11.4757 10.4583 11.375 10.3611 11.25 10.2917C10.5 9.91667 9.74306 9.63542 8.97917 9.44792C8.21528 9.26042 7.44444 9.16667 6.66667 9.16667C5.88889 9.16667 5.11806 9.26042 4.35417 9.44792C3.59028 9.63542 2.83333 9.91667 2.08333 10.2917C1.95833 10.3611 1.85764 10.4583 1.78125 10.5833C1.70486 10.7083 1.66667 10.8472 1.66667 11V11.6667ZM6.66667 5C7.125 5 7.51736 4.83681 7.84375 4.51042C8.17014 4.18403 8.33333 3.79167 8.33333 3.33333C8.33333 2.875 8.17014 2.48264 7.84375 2.15625C7.51736 1.82986 7.125 1.66667 6.66667 1.66667C6.20833 1.66667 5.81597 1.82986 5.48958 2.15625C5.16319 2.48264 5 2.875 5 3.33333C5 3.79167 5.16319 4.18403 5.48958 4.51042C5.81597 4.83681 6.20833 5 6.66667 5Z"
        fill={color}
      />
    </svg>
  );
}

export function PendingSectionIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.98438 0C4.45312 0 0 4.45312 0 9.98438C0 15.5156 4.45312 19.9688 9.98438 19.9688C15.5156 19.9688 19.9688 15.5156 19.9688 9.98438C19.9688 4.45312 15.5156 0 9.98438 0ZM9.98438 18C5.57812 18 1.96875 14.3906 1.96875 9.98438C1.96875 5.57812 5.57812 1.96875 9.98438 1.96875C14.3906 1.96875 18 5.57812 18 9.98438C18 14.3906 14.3906 18 9.98438 18ZM3.46875 9.98438C3.46875 9.14062 4.17188 8.48438 4.96875 8.48438C5.8125 8.48438 6.46875 9.14062 6.46875 9.98438C6.46875 10.8281 5.8125 11.4844 4.96875 11.4844C4.17188 11.4844 3.46875 10.8281 3.46875 9.98438ZM8.48438 9.98438C8.48438 9.14062 9.14062 8.48438 9.98438 8.48438C10.8281 8.48438 11.4844 9.14062 11.4844 9.98438C11.4844 10.8281 10.8281 11.4844 9.98438 11.4844C9.14062 11.4844 8.48438 10.8281 8.48438 9.98438ZM13.5 9.98438C13.5 9.14062 14.1562 8.48438 15 8.48438C15.7969 8.48438 16.5 9.14062 16.5 9.98438C16.5 10.8281 15.7969 11.4844 15 11.4844C14.1562 11.4844 13.5 10.8281 13.5 9.98438Z"
        fill="#2E8056"
      />
    </svg>
  );
}

export function PrintedSectionIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M19.9688 3.1875L8.57812 14.5781L4.3125 10.3594L5.76562 8.95312L8.57812 11.7656L18.5625 1.78125L19.9688 3.1875ZM17.7656 8.20312C17.9062 8.76562 18 9.375 18 9.98438C18 14.3906 14.3906 18 9.98438 18C5.57812 18 1.96875 14.3906 1.96875 9.98438C1.96875 5.57812 5.57812 1.96875 9.98438 1.96875C11.5781 1.96875 13.0312 2.4375 14.25 3.23438L15.7031 1.78125C14.0625 0.65625 12.0938 0 9.98438 0C4.45312 0 0 4.45312 0 9.98438C0 15.5156 4.45312 19.9688 9.98438 19.9688C15.5156 19.9688 19.9688 15.5156 19.9688 9.98438C19.9688 8.8125 19.7812 7.64062 19.4062 6.60938L17.7656 8.20312Z"
        fill="#2E8056"
      />
    </svg>
  );
}

export function ArchivedSectionIcon() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M17 5C17.5304 5 18.0391 4.78929 18.4142 4.41421C18.7893 4.03914 19 3.53043 19 3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3C1 3.53043 1.21071 4.03914 1.58579 4.41421C1.96086 4.78929 2.46957 5 3 5M17 5H3M17 5V15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H5C4.46957 17 3.96086 16.7893 3.58579 16.4142C3.21071 16.0391 3 15.5304 3 15V5M8 9H12"
        stroke="#2E8056"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ProgressChartIcon({ color = "#FFFFFF" }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3.33333 11.6667H5V7.5H3.33333V11.6667ZM10 11.6667H11.6667V3.33333H10V11.6667ZM6.66667 11.6667H8.33333V9.16667H6.66667V11.6667ZM6.66667 7.5H8.33333V5.83333H6.66667V7.5ZM1.66667 15C1.20833 15 0.815972 14.8368 0.489583 14.5104C0.163194 14.184 0 13.7917 0 13.3333V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H13.3333C13.7917 0 14.184 0.163194 14.5104 0.489583C14.8368 0.815972 15 1.20833 15 1.66667V13.3333C15 13.7917 14.8368 14.184 14.5104 14.5104C14.184 14.8368 13.7917 15 13.3333 15H1.66667ZM1.66667 13.3333H13.3333V1.66667H1.66667V13.3333ZM1.66667 1.66667V13.3333V1.66667Z"
        fill={color}
      />
    </svg>
  );
}

export function ActionGenerateIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0 1.71429C0 0.767512 0.795284 0 1.77632 0H10.8553C11.8363 0 12.6316 0.767512 12.6316 1.71429V7.23672C12.2572 7.08602 11.8604 6.97691 11.4474 6.91535V1.71429C11.4474 1.3987 11.1823 1.14286 10.8553 1.14286H1.77632C1.44931 1.14286 1.18421 1.3987 1.18421 1.71429V13.5238C1.18421 13.8394 1.44931 14.0952 1.77632 14.0952H6.10437C6.33111 14.515 6.61832 14.8996 6.95495 15.2381H1.77632C0.795284 15.2381 0 14.4706 0 13.5238V1.71429ZM9.67105 6.85714C9.75861 6.85714 9.84182 6.8755 9.91658 6.90842C8.95982 7.04206 8.0884 7.4304 7.37874 8H2.96053C2.63352 8 2.36842 7.74415 2.36842 7.42857C2.36842 7.11299 2.63352 6.85714 2.96053 6.85714H9.67105ZM2.96053 3.42857C2.63352 3.42857 2.36842 3.68441 2.36842 4C2.36842 4.31559 2.63352 4.57143 2.96053 4.57143H9.67105C9.99805 4.57143 10.2632 4.31559 10.2632 4C10.2632 3.68441 9.99805 3.42857 9.67105 3.42857H2.96053ZM15 11.8095C15 9.49516 13.056 7.61905 10.6579 7.61905C8.25979 7.61905 6.31579 9.49516 6.31579 11.8095C6.31579 14.1239 8.25979 16 10.6579 16C13.056 16 15 14.1239 15 11.8095ZM11.0531 12.1905L11.0535 14.0979C11.0535 14.3083 10.8768 14.4789 10.6588 14.4789C10.4408 14.4789 10.264 14.3083 10.264 14.0979L10.2636 12.1905H8.286C8.06818 12.1905 7.89166 12.02 7.89166 11.8095C7.89166 11.5992 8.06818 11.4286 8.286 11.4286H10.2636L10.2632 9.52328C10.2632 9.31284 10.4399 9.14232 10.6579 9.14232C10.8759 9.14232 11.0526 9.31284 11.0526 9.52328L11.053 11.4286H13.0236C13.2414 11.4286 13.418 11.5992 13.418 11.8095C13.418 12.02 13.2414 12.1905 13.0236 12.1905H11.0531Z"
        fill={GREEN}
      />
    </svg>
  );
}

export function ActionOmitIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M13.8158 13.7143C13.8158 13.9238 13.6389 14.0952 13.4211 14.0952H8.89563C8.6689 14.515 8.38168 14.8996 8.04505 15.2381H13.4211C14.2926 15.2381 15 14.5554 15 13.7143V5.96419C15 5.56038 14.8334 5.17257 14.5374 4.88686L9.93553 0.446476C9.92368 0.435086 9.91034 0.425204 9.89708 0.415391C9.88721 0.40813 9.8775 0.400914 9.86842 0.393143C9.81237 0.344381 9.75711 0.296381 9.69553 0.256C9.67555 0.243002 9.65376 0.232747 9.63197 0.222529C9.61934 0.216579 9.60671 0.210644 9.59447 0.20419C9.58129 0.197021 9.56818 0.189691 9.555 0.182347C9.51221 0.158453 9.46926 0.134461 9.42395 0.115809C9.26842 0.0533333 9.10105 0.0220952 8.93132 0.0106666C8.91576 0.00970662 8.90037 0.00768004 8.8849 0.00564575C8.8635 0.0028267 8.84203 0 8.82 0H3.94737C3.07579 0 2.36842 0.682667 2.36842 1.52381V7.23672C2.74277 7.08602 3.13957 6.97691 3.55263 6.91535V1.52381C3.55263 1.31429 3.72947 1.14286 3.94737 1.14286H8.68421V4.57143C8.68421 5.41257 9.39158 6.09524 10.2632 6.09524H13.8158V13.7143ZM9.86842 1.99695L12.93 4.95238H10.2632C10.0453 4.95238 9.86842 4.78095 9.86842 4.57143V1.99695ZM8.68421 11.8095C8.68421 14.1239 6.74019 16 4.34211 16C1.94402 16 0 14.1239 0 11.8095C0 9.49516 1.94402 7.61905 4.34211 7.61905C6.74019 7.61905 8.68421 9.49516 8.68421 11.8095ZM1.18421 11.8095C1.18421 12.4446 1.38549 13.0343 1.72983 13.5224L6.11702 9.28846C5.61119 8.95619 5.00016 8.7619 4.34211 8.7619C2.59805 8.7619 1.18421 10.1264 1.18421 11.8095ZM4.34211 14.8571C6.08616 14.8571 7.5 13.4926 7.5 11.8095C7.5 11.1745 7.29868 10.5848 6.95438 10.0966L2.56719 14.3306C3.07302 14.6629 3.68406 14.8571 4.34211 14.8571Z"
        fill={GREEN}
      />
    </svg>
  );
}

export function ActionEditIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M11.8362 2.66674L14.3344 5.16673M6.00698 4.39173C4.54617 4.60002 3.21865 5.35493 2.2922 6.50421C1.36575 7.65348 0.909317 9.11158 1.01497 10.5844C1.12063 12.0572 1.78051 13.4351 2.8615 14.4402C3.9425 15.4452 5.36416 16.0026 6.83972 16C8.24156 16.0001 9.59651 15.4948 10.6562 14.5765C11.716 13.6582 12.4095 12.3885 12.6098 11M8.50521 11L15.4878 3.98757C15.8157 3.65937 16 3.21423 16 2.75008C16 2.28593 15.8157 1.84079 15.4878 1.51259C15.1598 1.18438 14.715 1 14.2511 1C13.7873 1 13.3425 1.18438 13.0145 1.51259L6.00698 8.50004V11H8.50521Z"
        stroke={GREEN}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ActionDeleteIcon() {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12.6667 3.375L12.219 10.8948C12.1047 12.8151 12.0475 13.7754 11.5839 14.4659C11.3546 14.8073 11.0595 15.0955 10.7172 15.312C10.0248 15.75 9.09817 15.75 7.24473 15.75C5.38892 15.75 4.46099 15.75 3.7682 15.3112C3.42569 15.0943 3.13044 14.8056 2.90127 14.4636C2.43775 13.7719 2.38182 12.8101 2.27 10.8864L1.83333 3.375M0.75 3.375H4.39933M4.39933 3.375H10.1791M4.39933 3.375L4.83677 2.37844C5.15601 1.65116 5.31563 1.28753 5.60138 1.05988C5.66471 1.00943 5.73196 0.964507 5.80244 0.92559C6.12044 0.75 6.50524 0.75 7.27492 0.75C8.02574 0.75 8.40115 0.75 8.71394 0.918525C8.78335 0.955905 8.84972 0.999075 8.91234 1.04761C9.1948 1.26639 9.3586 1.6172 9.68613 2.3188L10.1791 3.375M10.1791 3.375H13.75M5.44444 11.625V7.125M9.05556 11.625V7.125"
        stroke={GREEN}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ActionArchiveIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3 7h18M5 7v11a2 2 0 002 2h10a2 2 0 002-2V7M9 11h6"
        stroke={GREEN}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4h16v3H4V4z"
        stroke={GREEN}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ActionUnarchiveIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3 7h18M5 7v11a2 2 0 002 2h10a2 2 0 002-2V7M12 17V11M9.5 13.5L12 11l2.5 2.5"
        stroke={GREEN}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4h16v3H4V4z"
        stroke={GREEN}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DashIconWrap({ children, variant = "light" }) {
  return (
    <span
      className={`dash-icon-wrap${
        variant === "dark" ? " dash-icon-wrap--dark" : ""
      }`}
    >
      {children}
    </span>
  );
}
